import { useState } from 'react';
import { Input } from '../Input/Input';
import { Button } from '../buttons/Button/Button';
import { CheckForm } from '../CheckForm/CheckForm';
import { Link } from '../Link/Link';
// import { ThankYouPage } from "./ThankYouPage";
import './form.scss';

export const CareerPageForm = () => {
    const [agreed, setAgreed] = useState(true);

    const onAgreed = value => {
        setAgreed(value);
    };
    const handleInputChange = e => {};

    const onSubmitForm = e => {
        e.preventDefault();
    };

    return (
        <form onSubmit={onSubmitForm} className="form">
            <div className="content-form-wrapper">
                <div className="inputs-line">
                    <label>
                        <span className="body3">FIRST NAME*</span>
                        <Input type="text" placeholder="Your name" name="first-name" onChange={handleInputChange} />
                    </label>
                    <label>
                        <span className="body3">LAST NAME*</span>
                        <Input type="text" placeholder="Your last name" name="last-name" onChange={handleInputChange} />
                    </label>
                </div>
                <div className="inputs-line">
                    <label>
                        <span className="body3">E-MAIL*</span>
                        <Input type="email" placeholder="E-mail" name="mail" onChange={handleInputChange} />
                    </label>
                    <label>
                        <span className="body3">PHONE</span>
                        <Input type="tel" pattern="[0-9]*" placeholder="Your phone number" name="phone" />
                    </label>
                </div>
                <label>
                    <span className="body3">YOUR MESSAGE*</span>
                    <textarea className="textarea" placeholder="Please enter your message" name="message"></textarea>
                </label>
                <Button type="attach-file" className="margin-bottom">
                    ATTACH A FILE
                </Button>
                <div className="submit-wrapper">
                    <div className="checkbox-wrapper">
                        <CheckForm onClick={onAgreed} checked={true}>
                            <span>
                                By clicking submit, you acknowledge that you have read
                                <br /> and agree to the
                            </span>{' '}
                            <Link href="https://www.google.com">Terms of Use</Link>
                            <span> and</span> <Link href="/#">Privacy Policy</Link>
                        </CheckForm>
                    </div>
                    <div className="submit-button">
                        <Button type={`${!agreed && 'disabled'} submit`}>SUBMIT</Button>
                    </div>
                </div>
            </div>
            {/* <ThankYouPage /> */}
        </form>
    );
};
